import { JSX } from "preact/jsx-runtime"
import mfcIcon from "static/icons/mfc-icon.svg"
import css from "../style.module.scss"

type LogoProps = {
  style?: JSX.CSSProperties
}

export const Logo = function Logo({ style }: LogoProps) {
  return (
    <div style={style}>
      <h2 className={css.logo}>
        <img src={mfcIcon} alt="MFC logo" width={40} className={css["logo-icon"]} />
        Mountain<span className={css.pro}>Pro</span>
      </h2>
    </div>
  )
}
